import React from 'react';
import {
    Header,
    Button,
    Grid,
    Segment,
    Loader,
    Image,
    Label,
    Input,
    Icon,
    Table,
    Form,
    Popup
} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

import PersonBasicInfoTable from '../../StudentPersonalInfo/PersonBasicInfoTable';
import PreviousEducation from '../../StudentPersonalInfo/PreviousEducationTable';
import ContactFormEditable from '../../util/ContactFormEditable';
import '../../StudentPersonalInfo/PersonalInfo.css';
import request from '../../util/request';
import { fetchPersonInfo, addContact, deleteContact } from '../../StudentPersonalInfo/request';
import StudentEdit from '../StudentCreateAndEdit/StudentEdit';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import PreviousEducations from '../StudentCreateAndEdit/PreviousEducations';
import SimpleTwoColumnTableRow from '../../StudentPersonalInfo/SimpleTwoColumnTableRow';
import { FormattedMessage } from 'react-intl';
import { extractFileNameFromHeaders } from '../../DegreeDocumentPrint/util/util';
import download from 'downloadjs';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


// const formatContacts = (contacts, contactTypes) => {
//     const c1 = contacts.map(c => ({
//         id: c.id,
//         contactType: contactTypes.find(el => el.text == c.type).value || null,
//         value: c.value
//     }));
//     return c1;
// };

// FIXME: role defaults to student, if employee pass isEmployee prop
export default class PersonalInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeRole: '',
            // error handling
            error: false,
            errorText: '',

            contactEditMode: false,
            editPhotoMode: false,
            editAccountMail: false,
            contactTypes: [],
            personData: {},
            loading: true,
            step: 0,
            src: '',
            selectedFile: null,
            currentSrc: ''

        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.onPersonIdChanged = this.onPersonIdChanged.bind(this);

        this.onAddNewPreviousEducation = this.onAddNewPreviousEducation.bind(this);
        this.onDeletePreviousEducation = this.onDeletePreviousEducation.bind(this);
        this.onEditPreviousEducation = this.onEditPreviousEducation.bind(this);

        this.switchContactEditMode = this.switchContactEditMode.bind(this);
        this.switchContactAddMode = this.switchContactAddMode.bind(this);
        this.updateContacts = this.updateContacts.bind(this);
        this.onAddNewContact = this.onAddNewContact.bind(this);
        this.onDeleteContact = this.onDeleteContact.bind(this);
        this.onEditContact = this.onEditContact.bind(this);
        this.switchPreviousEducationEditMode = this.switchPreviousEducationEditMode.bind(this);

        this.switchEditPhotoMode = this.switchEditPhotoMode.bind(this);

        this.fetchAccountMail = this.fetchAccountMail.bind(this);
        this.editAccountMail = this.editAccountMail.bind(this);
        this.switchAccountMailEditMode = this.switchAccountMailEditMode.bind(this);
    }

    componentDidMount() {
        let element = document.querySelectorAll('#myTab:nth-child(1)');
        element[0].childNodes[1].classList.remove('segment');

        request.fetchContactTypes().then(contactTypes => this.setState({ contactTypes }))
            .then(res => this.onPersonIdChanged());

        this.getPreviousEducations();

        axios.get(`/students/images/originals/${this.props.studentId}`)
            .then(res => {
                res.data ?
                    this.setState({ src: res.data })
                    : this.setState({ src: null })
                }
            ).catch(err => {
                this.setState({ src: null });
        });
         this.fetchAccountMail();

    }

    fetchAccountMail() {
        let obj = {
            id:this.props.studentId
        };
        axios.post('/user/get-user-data/', {...obj})
            .then(res => {
                // eslint-disable-next-line no-unused-expressions
                res.data ?
                    this.setState({ accountMail: res.data.eMail, username: res.data.username })
                    : this.setState({ accountMail: null });
            }).catch(err => {
            this.setState({ accountMail: null });
        });
    }

    getPreviousEducations() {
        let personId = this.props.studentId;
        axios.get(`previous-education/${personId}`)
            .then(res => this.setState({ previousEducations: res.data.reverse() }));
    }


    onAddNewPreviousEducation(prevEducation) {
            axios.post('previous-education/add', { ...prevEducation })
            .then(res => {
                toast('Uspješno ste dodali novo prethodno obrazovanje.');
                this.getPreviousEducations();
            })
            .catch(err => {
                toast('Došlo je do greške. Prethodno obrazovanje nije dodato.');
                console.log('Failed to add previous education.');
            });
    }

    onDeletePreviousEducation(previousEducationId) {
        if (this.state.previousEducations && this.state.previousEducations.length === 1) {
            toast('Osoba mora imati podatke o prethodnom obrazovanju. Dodajte novo kako bi izbrisali postojoće.');
        } else {
            axios.delete(`previous-education/delete/${previousEducationId}`)
                .then(res => {
                    toast('Uspješno ste izbrisali prethodno obrazovanje.');
                    this.getPreviousEducations();
                })
                .catch(err => {
                    toast('Došlo je do greške. Prethodno obrazovanje nije obrisano.');
                    console.log('Failed to add previous education.');
                });
        }
    }

    onEditPreviousEducation(prevEducation) {
        axios.put('previous-education/edit', { ...prevEducation })
            .then(res => {
                toast('Uspješno ste izmijenili prethodno obrazovanje.');
                this.getPreviousEducations();
            })
            .catch(err => {
                toast('Došlo je do greške. Prethodno obrazovanje nije izmijenjeno.');
                console.log('Failed to add previous education.');
            });
    }


    switchPreviousEducationEditMode() {
        request.fetchInstitutionTypes()
            .then(institutionTypes => this.setState({ institutionTypes }));

        request.fetchEducationLevels()
            .then(educationLevels => this.setState({ educationLevels }));
        this.setState(prevState => ({ previousEducationEditMode: !prevState.previousEducationEditMode }));
    }

    onPersonIdChanged() {
        fetchPersonInfo('studentska', this.state.contactTypes, this.props.studentId)
            .then(personData => {
                this.setState({ personData });
                this.props.getJMBG(personData.jmbg);
                this.setState({ loading: false });
            });
    }


    onDeleteContact(contactId) {
        deleteContact(contactId, 'Studentska', this.props.studentId)
            .then(res => { toast('Kontakt je uspješno izbrisan.'); this.updateContacts(); });
    }


    onEditContact(requestBody) {
        axios.put('/students/student/personal-information/change-contact', { ...requestBody })
            .then(res => {
                toast('Kontakt je uspješno izmijenjen.');
                this.updateContacts();
            })
            .catch(err => {
                toast('Došlo je do greške! Kontakt nije uspješno izmijenjen.');
            });
    }

    onAddNewContact(contact) {
        addContact(contact, this.state.contactTypes, 'administrator', this.props.studentId)
            .then(res => { toast('Uspješno ste dodali kontakt.'); this.updateContacts(); });
    }


    switchContactEditMode() {
        this.setState(prevState => ({ contactEditMode: !prevState.contactEditMode }));
    }

    updateContacts() {
        fetchPersonInfo('studentska', this.state.contactTypes, this.props.studentId)
            .then(personData => {
                this.setState({ personData });
                this.setState({ loading: false });
            });

    }
    switchContactAddMode() {
        this.setState(prevState => ({ contactAddMode: !prevState.contactAddMode }));
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    onFileChange = event => {
        this.setState({ selectedFile: event.target.files[0], currentSrc: URL.createObjectURL(event.target.files[0]) });
    };

    onFileUpload = () => {
        const formData = new FormData();
        formData.append(
            "imageFile",
            this.state.selectedFile,
            this.state.selectedFile.name
        );

        axios.post(`/students/${this.props.studentId}/uploadImage`, formData)
            .then(res=>{
                toast('Fotografija studenta je uspješno dodana.');
                this.setState({ selectedFile: null, currentSrc: '' });
                axios.get(`/students/images/originals/${this.props.studentId}`)
                    .then(res => {
                            res.data ?
                                this.setState({ src: res.data, editPhotoMode: false })
                                : this.setState({ src: null })
                        }
                    ).catch(err => {
                    this.setState({ src: null });
                });
            })
            .catch(err=> {
                toast('Došlo je do greške! Fotografija nije dodana.');
                this.setState({ selectedFile: null, currentSrc: '' });
            })
    };

    switchEditPhotoMode() {
        this.setState(prevState => ({ editPhotoMode: !prevState.editPhotoMode }));
    }
    switchAccountMailEditMode() {
        this.setState({ editAccountMail: !this.state.editAccountMail ,  accountMailErr: false})
    }

    editAccountMail(){
        this.setState({accountMailErr: false});
            axios.put(`user/edit-user-mail/${this.props.studentId}/`, this.state.accountMail)
                .then((res)=>{
                    this.fetchAccountMail();
                    this.switchAccountMailEditMode();
                    toast('Uspješno ste izmijenili e-mail!')
                })
                .catch(err=>{
                    this.setState({accountMail:null, accountMailErr:true});
                        toast('Došlo je do greške! Izmjena e-maila nije izvršena.')
                })
    }

    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        // const src = 'https://image.freepik.com/free-icon/user-image-with-black-background_318-34564.jpg';
        const {
            personData,
            accountMail
        } = this.state;
        const activeRole = localStorage.getItem('activeRole') || '';
        const canManageAccessData = activeRole.substr(0, 10) === 'Studentska' || activeRole === 'Administrator';
        if (this.state.step === 1) {
            return (
                <StudentEdit

                    personData={this.state.personData}
                    studentId={this.props.studentId}
                    studyProgramId={this.props.studyProgramId}
                    changeStep={(personData) => this.setState({ personData, step: 0 },()=>{
                        request.fetchContactTypes().then(contactTypes => this.setState({ contactTypes }))
                            .then(res => this.onPersonIdChanged());

                        axios.get(`/students/images/originals/${this.props.studentId}`)
                            .then(res => {
                                    res.data ?
                                        this.setState({ src: res.data })
                                        : this.setState({ src: null })
                                }
                            ).catch(err => {
                            this.setState({ src: null });
                        });
                    })}
                />);
        }
        return (
            <div >
                {/*{*/}
                {/*    !this.props.limitation && <Button*/}
                {/*    disabled={localStorage.getItem('activeRole') === 'AIDA'|| localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}*/}
                {/*    color="blue" basic='true' floated='right' onClick={() => this.setState({ step: 1 })}>Izmjena podataka</Button>*/}
                {/*}*/}
                {/*<br/>*/}
                {/*<br/>*/}
                {/*<br/>*/}
                <Grid className="stackable" centered>
                    <Grid.Row stretched>
                        <Grid.Column >
                            <Segment.Group >
                                <Segment clearing>
                                    <Header as="h3">
                                        {canManageAccessData && (this.state.username ? <Header style={IconHeader} floated="right" >
                                                <Icon />
                                                <Icon link circular
                                                  style={{
                                                      pointerEvents: this.props.limitation ? "none" : "auto",
                                                      opacity: this.props.limitation ? 0.5 : 1,
                                                  }}
                                                  basic="true" floated="right" name={this.state.editAccountMail ? 'close' : 'pencil'} disabled={this.props.limitation}
                                                  color={this.state.editAccountMail ? null : 'green'} onClick={this.props.limitation ? null : this.switchAccountMailEditMode} />

                                            </Header> :
                                            <Header style={IconHeader} floated="right" >
                                                <Popup
                                                    content="Generiši pristupne podatke"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            onClick={()=>{
                                                                axios({
                                                                    method: 'post',
                                                                    url: `/generate-users/student/${this.props.ssp}/`,
                                                                    responseType: 'blob'
                                                                })
                                                                    .then((res)=>{
                                                                        this.fetchAccountMail();
                                                                        const fileName = extractFileNameFromHeaders(res.headers);
                                                                        download(res.data, fileName);
                                                                        toast('Uspješno ste generisali pristupne podatke.')
                                                                    }).catch(err=>{
                                                                    axios({
                                                                        method: 'post',
                                                                        url: `/generate-users/student/${this.props.ssp}/`,
                                                                    })
                                                                        .then((res)=>{
                                                                            this.fetchAccountMail();
                                                                            const fileName = extractFileNameFromHeaders(res.headers);
                                                                            download(res.data, fileName);
                                                                            toast('Uspješno ste generisali pristupne podatke.')
                                                                        }).catch(err=>{
                                                                        if (err.response.data === 'Student is dropped out!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za ispisane studente.');
                                                                        } else if (err.response.data === 'Student is graduated!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za studente koji su diplomirali.');
                                                                        } else if (err.response.data === 'Student is locked!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za zaključane studente.');
                                                                        } else if (err.response.data === 'Student already has an account!') {
                                                                            toast('Student već ima pristupne podatke.');
                                                                        } else if (err.response.data === 'Student switched to new study program!') {
                                                                            toast('Student je prešao na novi studijski program.');
                                                                        } else if (err.response.data === 'Student is not enrolled in current academic year!') {
                                                                            toast('Generisanje pristupnih podataka nije moguće za studente koji nisu upisani u trenutnu akademsku godinu.');
                                                                        } else {
                                                                            toast('Došlo je do greške! Pristupni podaci nisu generisani.');
                                                                        }
                                                                    })
                                                                })
                                                            }}
                                                            size="small"
                                                            style={FiltersOnStyle}
                                                            basic
                                                            color="blue" fluid
                                                        >
                                                            Pristupni podaci

                                                        </Button>}
                                                />


                                            </Header>
                                        )}
                                        Podaci korisničkog računa
                                    </Header>
                                </Segment>
                                <Segment clearing>
                                <Grid columns={2} className="stackable" centered>
                                    <Grid.Column>
                                            <Table celled size="small" unstackable compact>
                                                <Table.Body>
                                                    <Table.Row>
                                                        <Table.Cell textAlign="right" verticalAlign="middle">
                                                            <strong><FormattedMessage id="common.username" /></strong>
                                                        </Table.Cell>
                                                        <Table.Cell>
                                                            <Grid>
                                                                <Grid.Column width={8} verticalAlign="middle" >
                                                                   { this.state.username }
                                                                </Grid.Column>
                                                            </Grid>
                                                        </Table.Cell>
                                                    </Table.Row>
                                                </Table.Body>
                                            </Table>

                                    </Grid.Column>
                                    <Grid.Column>
                                        <Table celled size="small" compact>
                                            <Table.Body>
                                                <Table.Row>
                                                    <Table.Cell textAlign="right" verticalAlign="middle">
                                                        <strong><FormattedMessage id="common.accountMail" /></strong>
                                                    </Table.Cell>
                                                    <Table.Cell verticalAlign="middle">
                                                                {(this.state.editAccountMail) ?
                                                                    <Form size="mini">
                                                                        <Grid columns={2} stackable verticalAlign={'middle'}>
                                                                            <Grid.Column width={13} verticalAlign="middle">
                                                                                <Form.Field error={this.state.accountMailErr}>
                                                                                <input
                                                                                    placeholder="Unesite e-mail"
                                                                                    value={accountMail}
                                                                                    onChange={(e) => this.setState({ accountMail: e.target.value })}
                                                                                    name="input"
                                                                                />

                                                                            </Form.Field>
                                                                            </Grid.Column>
                                                                            <Grid.Column width={1} verticalAlign="middle">
                                                                                <Form.Field >
                                                                                <Button
                                                                                    compact
                                                                                    circular
                                                                                    floated={'right'}
                                                                                    icon="check"
                                                                                    size="mini"
                                                                                    basic="true"
                                                                                    color="blue"
                                                                                    onClick={this.editAccountMail}
                                                                                />
                                                                                </Form.Field>
                                                                            </Grid.Column>
                                                                        </Grid>
                                                                    </Form>
                                                                    : accountMail
                                                                }
                                                    </Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>

                                    </Grid.Column>
                                </Grid>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <Grid columns={2} className="stackable" centered>
                    <Grid.Row stretched>
                        <Grid.Column >
                            <Segment.Group >
                                <Segment>
                                    <Header as="h3">
                                        { (localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'Administrator' ) && <Header style={IconHeader} floated="right" >
                                            <Icon />

                                            <Icon link circular basic="true" floated="right" name="pencil" color="green" disabled={this.props.limitation}
                                                  style={{
                                                      pointerEvents: this.props.limitation ? "none" : "auto",
                                                      opacity: this.props.limitation ? 0.5 : 1,
                                                  }}
                                                  onClick={() => {
                                                        if (!this.props.limitation) {
                                                            this.setState({ step: 1 });
                                                        }}}
                                            />
                                            <Popup
                                                trigger={<Icon link circular basic="true" floated="right" name="info"  />}
                                                content="Ukoliko je student aktivan na više fakulteta, studentske službe imaju mogućnost izmjene ličnih podataka i izmjene su vidljive studentskim službama svih fakulteta."
                                                hideOnScroll
                                                position="top center"
                                            />
                                        </Header>}
                                        Osnovne informacije
                                    </Header>
                                </Segment>
                                <Segment textAlign="center" verticalAlign="middle">
                                    <PersonBasicInfoTable personInfoData={personData} accountMail={accountMail}/>
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment.Group  style={{
                                height: '400px',
                            }}>
                                <Segment>
                                    <Header as="h3">
                                        { (localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'Administrator' ) && <Header style={IconHeader} floated="right" >
                                            <Icon />
                                            <Icon
                                                link
                                                circular
                                                basic="true"
                                                floated="right"
                                                style={{
                                                    pointerEvents: this.props.limitation ? "none" : "auto",
                                                    opacity: this.props.limitation ? 0.5 : 1,
                                                }}
                                                disabled={this.props.limitation}
                                                name={this.state.editPhotoMode ? 'close' : 'pencil'}
                                                color={this.state.editPhotoMode ? null : 'green'}
                                                onClick={this.props.limitation ? null : this.switchEditPhotoMode} />
                                        </Header>}
                                        Fotografija
                                    </Header>
                                </Segment>
                                <Segment textAlign="center" clearing verticalAlign="middle" style={{
                                    height: localStorage.getItem('activeRole') === 'Support' ? '80%' : '70%',
                                }}  >
                                    {
                                       (this.state.src !== null && !this.state.editPhotoMode ) ?

                                           <Image src={`data:image/jpeg;base64,${this.state.src}`}
                                                  style={{
                                                      maxHeight: '100%'
                                                  }}
                                                  centered verticalAlign={"middle"} />
                                           :
                                           <div>
                                           <br/>
                                           <br/>

                                               { (this.state.selectedFile === null )?
                                                   <div style={{textAlign:'center', marginTop:'20%', marginBottom: localStorage.getItem('activeRole') === 'Support' ? '10%' : '20%'}}>
                                                       <Button as='div' labelPosition='right'>
                                                       <Button disabled={this.props.limitation || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Support' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')} color='blue' as="label" htmlFor="file" type="button"  onChange={this.onFileChange}>
                                                           <Icon name='upload' />
                                                       </Button>
                                                       <Label  style={{cursor:'none'}} basic pointing='left'>
                                                               Odaberite fotografiju
                                                       </Label>
                                                   </Button>

                                                   <Input type="file" id="file" style={{ display: "none" }} onChange={this.onFileChange} />
                                                   </div>
                                               : <div style={{
                                                       textAlign: 'center',
                                                       height: '320px',
                                                   }}>
                                                       <Image src={this.state.currentSrc}
                                                              style={{
                                                                  maxWidth: '100%',
                                                                  maxHeight: '100%'
                                                              }} centered />
                                                       <Button disabled={this.state.selectedFile === null} color="blue" onClick={this.onFileUpload}>
                                                           Sačuvaj
                                                       </Button>
                                                       <Button disabled={this.state.selectedFile === null} color="blue" basic onClick={()=>this.setState({selectedFile: null, currentArc: ''})}>
                                                           Poništi
                                                       </Button>
                                                   </div>
                                               }

                                               <br/>
                                               <br/>
                                       </div>

                                    }
                                </Segment>
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row stretched>
                        <Grid.Column >
                            <Segment.Group >
                                <Segment clearing>
                                    <Header as="h3">
                                        { (localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole') === 'Administrator' ) && <Header style={IconHeader} floated="right" >
                                            <Icon />
                                            <Icon
                                                link
                                                circular
                                                basic="true"
                                                floated="right"
                                                style={{
                                                    pointerEvents: this.props.limitation ? "none" : "auto",
                                                    opacity: this.props.limitation ? 0.5 : 1,
                                                }}
                                                name={this.state.contactEditMode ? 'close' : 'pencil'}
                                                color={this.state.contactEditMode ? null : 'green'}
                                                onClick={this.props.limitation ? null : this.switchContactEditMode} />
                                        </Header>}
                                        Kontakt
                                    </Header>
                                </Segment>
                                <ContactFormEditable
                                    contacts={this.state.personData.contacts || []}
                                    editMode={this.state.contactEditMode}
                                    contactTypes={this.state.contactTypes}
                                    onAddNewContact={this.onAddNewContact}
                                    onDeleteContact={this.onDeleteContact}
                                    onEditContact={this.onEditContact}
                                    contactEditMode={this.state.contactEditMode}
                                />
                            </Segment.Group>
                        </Grid.Column>
                        <Grid.Column>
                            <Segment.Group >
                                <Segment clearing>
                                    <Header as="h3">
                                            {localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu' && !localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu') &&
                                                <Header style={IconHeader} floated="right" >
                                                <Icon/>
                                                <Icon
                                                disabled={this.props.limitation}
                                                link circular
                                                basic="true"
                                                floated="right"
                                                name={this.state.previousEducationEditMode ? 'close' : 'pencil'}
                                                color={this.state.previousEducationEditMode ? null : 'green'}
                                                onClick={this.props.limitation ? null : this.switchPreviousEducationEditMode}
                                                style={{
                                                    pointerEvents: this.props.limitation ? 'none' : 'auto',
                                                    opacity: this.props.limitation ? 0.5 : 1,
                                                }}/>
                                            </Header>}

                                        Prethodno obrazovanje

                                    </Header>
                                    {this.state.previousEducationEditMode &&<PreviousEducations
                                                    institutionTypes={this.state.institutionTypes}
                                                    educationLevels={this.state.educationLevels}
                                                    institutions={this.state.institutions}
                                                    onAddNewPreviousEducation={this.onAddNewPreviousEducation}
                                                    previousEducations={this.state.previousEducations}
                                                    onDeletePreviousEducation={this.onDeletePreviousEducation}
                                                    onEditPreviousEducation={this.onEditPreviousEducation}
                                                    editMode
                                                    noSegment
                                                />}
                                </Segment>
                                    {!this.state.previousEducationEditMode && <Segment clearing>
                                    {(this.state.previousEducations && this.state.previousEducations.length !== 0) ? <Table celled size="small" unstackable compact>
                                        <Table.Header>
                                            <Table.Row />
                                        </Table.Header>
                                        <Table.Body>{this.state.previousEducations.map(el =>
                                            (<SimpleTwoColumnTableRow
                                                    name={el.institution.type ? el.institution.type.name.substring(0, 1).toUpperCase() + el.institution.type.name.substring(1) : ''}
                                                    keyName="institution"
                                                    value={el.educationLevel ? el.institution.name + ' | ' + el.educationLevel.name : el.institution.name}
                                                />
                                            ))}
                                        </Table.Body>
                                    </Table> : 'Nema podataka o prethodnom obrazovanju.'}
                                    </Segment>}
                            </Segment.Group>
                        </Grid.Column>
                    </Grid.Row>

                </Grid>
                <ToastContainer hideProgressBar />

            </div>
        );
    }
}

// const PersonInfoCardImage = ({ firstName, lastName, imageSource }) => (
//     <Segment color="blue">
//         <Grid columns={2} >
//             <Grid.Column width={6} >
//                 <Image src={imageSource} size="small" floated="left" />
//             </Grid.Column >
//             <Grid.Column width={10} textAlign="center" verticalAlign="middle">
//                 <h2>
//                     {firstName} {' '} {lastName}
//                 </h2>
//             </Grid.Column >
//         </Grid>
//     </Segment>
// );



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/PersonalInfo.js